/**
 * Directive: renderFinish
 */
angular.module('acme.common.directive.renderFinish', [])
.directive('renderFinish', [ '$timeout', function($timeout) {

  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      if (scope.$last === true) {
        $timeout(function () {
          scope.$emit('ngRepeatFinished');
        });
      }
    }
  };

}]);